<template>
  <div class="house">
    <div class="rightmouse"
         :style="{
        top: rightMouseTop + 'px',
        left: rightMouseLeft + 'px',
        opacity: rightMouseFlag ? '1' : '0',
      }">
      <p>© 图片版权保护</p>
    </div>
    <div class="househeader">
      <div style="display: flex; align-items: center">
        <img src="@/assets/house/breadicon.png"
             style="margin-right: 10px"
             alt />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>媒资检索</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div @click="refresh"
           class="refresh">
        <img :class="isRefresh ? 'imgmove' : ''"
             width="16px"
             height="16px"
             src="@/assets/house/refresh.png"
             alt />
        <p>刷新</p>
      </div>
    </div>

    <div v-loading="isRefresh">
      <div class="select">
        <h4>媒资检索</h4>

        <div class="belongpic"
             v-if="powersObj.advSearchPicture">
          <h5>所属资源库:</h5>
          <p v-for="(e, i) in belongPicList"
             :key="i"
             @click="picClick(i, e.id)"
             :style="{'backgroundColor': belongPicFlag === i ?  isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3' : 'transparent'}"
             :class="belongPicFlag === i ? 'active' : ''">
            {{ e.name }}
          </p>
        </div>

        <div class="belongpic"
             v-if="powersObj.advSearchPicture && !isSimple">
          <h5>图片主题:</h5>
          <p v-for="(e, i) in themeList"
             :key="i"
             @click="themeClick(i, e.id)"
             :class="themeFlag === i ? 'active' : ''">
            {{ e.name }}
          </p>
        </div>

        <div class="belongpic"
             v-if="powersObj.advSearchPicture && !isSimple">
          <h5>所属环境:</h5>
          <p v-for="(e, i) in environmentList"
             :key="i"
             @click="environmentClick(i, e.id)"
             :class="environmentFlag === i ? 'active' : ''">
            {{ e.name }}
          </p>
        </div>

        <div class="conditionselect"
             v-if="powersObj.advSearchPicture">
          <h5>条件筛选:</h5>

          <!-- 投稿人 -->
          <div class="coninput disflex">
            <p>投稿人:</p>
            <el-select v-model="contributor"
                       filterable
                       placeholder="不限">
              <el-option v-for="item in contributorList"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value"
                         v-html="'<span style=color:#303030;>'+item.label+'</span>'"></el-option>
            </el-select>
          </div>

          <!-- 关联事件 -->
          <div v-if="false"
               class="coninput disflex">
            <p>关联事件:</p>
            <el-select v-model="associatedEvents"
                       placeholder="不限">
              <el-option v-for="item in contributorList"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value"
                         v-html="'<span style=color:#303030;>'+item.label+'</span>'"></el-option>
            </el-select>
          </div>

          <!-- 入库时间 -->
          <div class="coninput disflex">
            <p>入库时间:</p>
            <el-date-picker v-model="warehousingTime"
                            type="daterange"
                            align="center"
                            value-format="timestamp"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"></el-date-picker>
            <!-- <i class="dateicon el-icon-date"></i> -->
          </div>

          <!-- 人脸筛选 -->
          <div v-if="!isPic && !isSimple"
               :class="
              displayResolution < 1800 ? 'coninput disflex' : 'coninput disflex'
            ">
            <p>人物筛选:</p>
            <el-select v-model="face"
                       remote
                       :remote-method="selectFacePeople"
                       filterable
                       placeholder="不限">
              <el-option v-for="item in facePeopleList"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value"
                         v-html="'<span style=color:#303030;>'+item.label+'</span>'"></el-option>
            </el-select>
          </div>

          <!-- 图片大小 -->
          <div v-if="false"
               :class="
              displayResolution < 1800
                ? 'margintop coninput disflex'
                : 'coninput disflex'
            ">
            <p>图片大小:</p>
            <el-select v-model="size"
                       placeholder="不限">
              <el-option v-for="item in contributorList"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value"
                         v-html="'<span style=color:#303030;>'+item.label+'</span>'"></el-option>
            </el-select>
          </div>
        </div>

        <div class="selectinput"
             v-if="powersObj.advSearchPicture">
          <el-row>
            <el-col :span="22">
              <el-input class="elinput"
                        @keyup.enter.native="searchClick"
                        v-model="selectInput"
                        clearable
                        placeholder="请输入关键字"></el-input>
            </el-col>
            <el-col :span="2">
              <el-button @click="searchClick"
                         :style="{'backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                         class="btn">搜索</el-button>
            </el-col>
          </el-row>
        </div>
      </div>
      <seePeopleFace ref="seePeopleFace"></seePeopleFace>

      <div class="main">
        <div class="head disflex">
          <div class="left">
            <el-button @click="columnSwitch(false)"
                       :class="isPic ? 'btn' : isSimple ? 'btn simpleactive' : 'btn active'">图片</el-button>

            <el-button @click="columnSwitch(true)"
                       :class="isPic ? isSimple ? 'btn simpleactive' : 'btn active' : 'btn'">图集</el-button>

          </div>

          <div @click="sortClick"
               class="right disflex">
            <p>按时间排序</p>
            <img style="margin: 3px 0 0 5px"
                 :src=" sortFlag ?require('@/assets/personpic/down.png'): isSimple ? require('@/assets/personpic/simpleup.png') : require('@/assets/personpic/up.png')"
                 alt />
          </div>
        </div>
        <div v-if="!showGifFlag">
          <div v-if="isPic"
               v-loading="loading"
               :style="{ 'grid-template-columns': `repeat(${row},1fr)` }"
               class="piclist">
            <div class="mypic"
                 v-for="(e, i) in picList"
                 :key="i">
              <div style="width: 275px; height: 200px; overflow: hidden">
                <div class="pic"
                     @click="intoPicList(e.id)"
                     :style="{ backgroundImage: 'url(' + e.src + ')' }">
                  <div class="sheets">
                    {{ e.pictureCount }}
                    <span>张</span>
                  </div>
                </div>
              </div>
              <el-tooltip class="item"
                          effect="dark"
                          :content="e.name"
                          placement="top">
                <p v-if="e.name.length > 13">
                  {{ e.name.substring(0, 13) + "…" }}
                </p>
              </el-tooltip>
              <p v-if="e.name.length <= 13">{{ e.name }}</p>
              <div class="disflex">
                <p style="margin-top: 5px; color: #999999">{{ e.mycreateAt }}</p>
                <!-- <div :class="e.isMode ? 'open' : 'private'">{{e.isMode ? '公开' : '私密'}}</div> -->
              </div>
              <div class="disflex">
                <p style="margin-top: 5px; color: #999999">
                  {{ "创建人：" + e.createName }}
                </p>
                <!-- <div :class="e.isMode ? 'open' : 'private'">{{e.isMode ? '公开' : '私密'}}</div> -->
              </div>
              <div class="btnlist disflex">
                <!-- <div v-if="powersObj.pictureShare"
                   @click.stop="shareClick(e)"
                   title="下载图集"
                   class="btn disflex">
                <div class="img"></div>
              </div> -->
                <el-tooltip class="item"
                            effect="dark"
                            content="下载图集"
                            placement="top">
                  <div v-if="powersObj.picturePush"
                       @click.stop="downLoadPicAtlas(e)"
                       :class="isSimple ? 'simplebtn disflex' : 'btn disflex'">
                    <div class="img"></div>
                  </div>
                </el-tooltip>
                <!-- <el-tooltip class="item"
                            effect="dark"
                            content="分享图集"
                            placement="top">
                  <div v-if="powersObj.picturePush"
                       @click.stop="sharePicAtlas(e)"
                       :class="isSimple ? 'simplebtn disflex' : 'btn disflex'">
                    <div class="imgshare"></div>
                  </div>
                </el-tooltip>
                <el-tooltip class="item"
                            effect="dark"
                            content="推送图集"
                            placement="top">
                  <div v-if="powersObj.picturePush"
                       @click.stop="pushClick(e)"
                       :class="isSimple ? 'simplebtn disflex' : 'btn disflex'">
                    <div class="img1"></div>
                  </div>
                </el-tooltip> -->
              </div>
            </div>

            <template v-if="picList.length === 0">
              <div class="nopic">
                <img src="@/assets/piclist/nonr.png"
                     alt />
              </div>
            </template>

            <img v-if="showLoading"
                 class="myloading"
                 width="200px"
                 src="@/assets/blue-preloader.gif"
                 alt />
          </div>

          <div v-if="!isPic"
               class="piclist">

            <section v-if="notpicList.length !== 0">
              <div class="img-wrapper"
                   v-for="(item, index) in notpicList"
                   :key="index">
                <!-- <transition name="fade" @enter="enter"> -->
                <el-image class="img"
                          @contextmenu.prevent="rightShow($event)"
                          ondragstart="return false;"
                          @click="
                  notpicList[0].src !== require('@/assets/house/grey.png') &&
                    openDialog(index, item)
                "
                          ref="loveImg"
                          :src="item.src">
                  <div slot="error"
                       class="image-slot">
                    <img src="@/assets/house/onloadpicerror.png"
                         alt="" />
                  </div>
                </el-image>
                <!-- </transition> -->
                <el-tooltip class="item"
                            effect="dark"
                            content="删除图片"
                            placement="top">
                  <div v-if="powersObj.manageAtlas"
                       @click.stop="deletePic(item, index)"
                       class="delete">
                    <img src="@/assets/piclist/delete.png"
                         alt />
                  </div>
                </el-tooltip>

                <el-tooltip class="item"
                            effect="dark"
                            content="选用图片"
                            placement="top">
                  <div @click.stop="lovePic(item, index)"
                       v-if="powersObj.selectPicture"
                       class="love">
                    <img v-if="loveList.indexOf(item.id) === -1"
                         src="@/assets/piclist/love.png"
                         alt />
                    <img v-if="loveList.indexOf(item.id) > -1"
                         src="@/assets/piclist/lovec.png"
                         alt />
                  </div>
                </el-tooltip>

                <!-- 修改图片信息 -->
                <el-tooltip class="item"
                            effect="dark"
                            content="修改图片说明"
                            placement="top">
                  <div @click.stop="openChangeDesc(item)"
                       v-if="powersObj.manageAtlas"
                       class="changedesc">
                    <img src="@/assets/sreenpic/desc.png"
                         alt="" />
                  </div>
                </el-tooltip>
              </div>

              <img v-if="showLoading"
                   class="myloading"
                   width="200px"
                   src="@/assets/blue-preloader.gif"
                   alt />
            </section>

            <div style="width:100%;text-align:center;"
                 v-if="searchLoading">
              <img width="200px"
                   src="@/assets/blue-preloader.gif"
                   alt />
            </div>

            <template v-if="notpicList.length === 0 && !searchLoading">
              <div class="nopic">
                <img src="@/assets/piclist/nonr.png"
                     alt />
              </div>
            </template>
          </div>
        </div>
        <div v-else
             style="height:500px;width:100%;display:flex;justify-content:center;align-items: center;">
          <img width="200px"
               height="200px"
               src="@/assets/blue-preloader.gif"
               alt />
        </div>
      </div>
    </div>

    <changedescdialog :message="message"
                      :dialogVisible="descdialogVisible"
                      @handleClose="deschandleClose"
                      @changeDesc="changeDesc"></changedescdialog>

    <el-dialog width="26%"
               :before-close="handleClosePic"
               :visible.sync="mydialogVisible">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>推送至图片邀约</div>
      </div>
      <el-form :model="myform"
               ref="myform"
               label-width="70px"
               :rules="rules">
        <!-- <el-form-item v-if="isSee" label="渠道名称：" prop="name">
            <el-input v-model="myform.name" placeholder="必填，2-10个字"></el-input>
        </el-form-item>-->
        <el-form-item label="标题："
                      prop="name">
          <el-select style="width: 100%"
                     v-model="myform.name"
                     filterable
                     @change="myformChange"
                     clearable
                     placeholder="请选择标题">
            <el-option v-for="(e, i) in picInviteList"
                       :key="i"
                       :label="e.title"
                       :value="e.title"
                       v-html="'<span style=color:#303030;>'+e.title+'</span>'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div slot="label"
               class="labelclass">备注：</div>
          <el-input type="textarea"
                    :autosize="{ minRows: 7 }"
                    v-model="myform.note"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="quitPic">取 消</el-button>
        <el-button type="primary"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   @click="submitPic('myform')">提 交</el-button>
      </div>
    </el-dialog>

    <el-dialog width="24%"
               :before-close="handleClosePush"
               :visible.sync="pushdialogVisible">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>选择推送渠道</div>
      </div>
      <div class="pushbj">
        <div @click.stop="choosePush(i, e.template, e.name, e.id)"
             :class="pushIndex === i ? 'pushlist active' : 'pushlist'"
             v-for="(e, i) in pushList"
             :key="i">
          {{ e.name }}
          <img v-if="pushIndex === i"
               src="@/assets/house/checkInside.png"
               alt />
        </div>
      </div>
    </el-dialog>

    <!-- 图片点击弹窗 -->
    <el-dialog :visible.sync="dialogVisible"
               width="90%"
               top="12vh"
               class="seePic"
               :show-close="false">
      <!-- 关闭按钮 -->
      <div @click="dialogVisible = false"
           class="close">
        <img :style="{ 'margin-top': displayResolution < 1600 ? '-2px' : '0px' }"
             src="@/assets/picbrowse/close.png"
             alt="" />
      </div>

      <div class="left">
        <div class="pic"
             v-loading="imgLoading"
             element-loading-text="正在加载图片中"
             element-loading-spinner="el-icon-loading"
             element-loading-background="rgba(0, 0, 0, 0.8)">
          <!-- <el-switch style="position:absolute;top:20px;right:20px;"
                     v-model="switechValue"
                     @change="clearLargeAndSmall">
          </el-switch> -->
          <div class="imgBj"
               ref="imgBj">
            <!-- <img ref="imgPic"
                 height="78%"
                 v-drag
                 v-lazy="choosePicMsg.src"
                 v-if="!switechValue"> -->
            <img ref="imgPic"
                 @contextmenu.prevent="rightShow($event)"
                 ondragstart="return false;"
                 height="98%"
                 :style="seeFull ? 'cursor:zoom-out' : 'cursor:zoom-in'"
                 @click="seeBigSmall"
                 v-lazy="choosePicMsg.src" />
            <div v-if="switechValue"
                 class="origin">
              <div class="faceBorder"
                   :style="
                  'position: absolute;display:flex;justify-content:center;align-items:center;border:1px dashed #00ccff;;height:' +
                  item.height +
                  'px;width:' +
                  item.width +
                  'px;top:' +
                  item.top +
                  'px;left:' +
                  item.left +
                  'px;'
                "
                   v-for="(item, index) in choosePicMsg.faceInfo"
                   :key="index">
                <div style="width: 93%; height: 93%; border: 1px dotted #666">
                  <div class="yuan"
                       :style="{
                      left: item.width - 20 + 'px',
                      top: item.height / 2 + 'px',
                    }"></div>
                  <div class="faceName"
                       :title="item.peopleName"
                       @click="!seeFull && getFaceId(item, index)"
                       :style="{
                      left: item.width - 10 + 'px',
                      top: item.height / 2 - 10 + 'px',
                    }">
                    {{
                      item.peopleName.length > 9
                        ? item.peopleName.substring(0, 9) + "…"
                        : item.peopleName
                    }}
                  </div>
                </div>
              </div>
            </div>

            <div @click="bigLeft"
                 class="leftjt">
              <div class="message"
                   v-show="showMessageLeft">这是第一张哟~</div>
            </div>
            <div @click="bigRight"
                 class="rightjt">
              <div class="message"
                   v-show="showMessageRight">这是最后一张哟~</div>
            </div>
            <i @click="picRotateRight"
               v-if="seeFull"
               class="el-icon-refresh-right"
               style="
                position: absolute;
                bottom: 20px;
                left: 45%;
                font-size: 30px;
              "></i>
            <i @click="picRotateLeft"
               v-if="seeFull"
               class="el-icon-refresh-left"
               style="position: absolute; bottom: 20px; font-size: 30px"></i>
          </div>
          <!-- <img height="78%" :src="choosePicMsg.src"> -->

          <!-- <div class="picBtn"
               v-if="!switechValue">
            <i @click="picRotateRight"
               class="el-icon-refresh-right"></i>
            <i @click="picLarge"
               class="el-icon-zoom-in"></i>
            <i @click="picSmall"
               class="el-icon-zoom-out"></i>
            <i @click="picRotateLeft"
               class="el-icon-refresh-left"></i>
          </div> -->
        </div>

        <div class="picinf disflex">
          <p></p>
          <!-- <p class="picinfleft">{{atlasInfo.name}} / 共<span>{{atlasInfo.pictureCount}}</span>张</p> -->
          <div class="picinfright disflex"
               v-if="choosePicMsg.errortext !== 'error'">
            <div @click.stop="seeFace"
                 v-if="!isSimple"
                 class="disflex face"
                 :style="{
                background: !switechValue
                  ? 'url(' +
                    require('@/assets/picbrowse/face.png') +
                    ') no-repeat'
                  : 'url(' +
                    require('@/assets/picbrowse/facehover.png') +
                    ') no-repeat',
              }">
              <div class="icon"></div>
              <!-- <img src="@/assets/picbrowse/spare.png" alt=""> -->
              <p :style="{ color: switechValue ? '#6ea4ff' : '#FFFFFF' }">
                人脸({{ faceLength }})
              </p>
            </div>
            <div v-if="powersObj.createAtlas"
                 @click.stop="lovePic"
                 class="disflex spare"
                 :style="{
                background: !haslovechange
                  ? 'url(' +
                    require('@/assets/picbrowse/spare.png') +
                    ') no-repeat'
                  : 'url(' +
                    require('@/assets/picbrowse/sparelove.png') +
                    ') no-repeat',
              }">
              <div class="icon"></div>
              <!-- <img src="@/assets/picbrowse/spare.png" alt=""> -->
              <p>选用</p>
            </div>
            <!-- <div v-if="powersObj.createAtlas" @click="setIndexPic" class="disflex book">
              <div class="icon"></div>
              <p>设为封面</p>
            </div> -->
            <div v-if="powersObj.manageAtlas"
                 @click="deletePic"
                 class="disflex delete">
              <div class="icon"></div>
              <!-- <img src="@/assets/picbrowse/delete.png" alt=""> -->
              <p>删除</p>
            </div>
            <!-- <div @click.stop="dev" class="disflex download">
              <div class="icon"></div>
              <p>下载原图 <span style="font-size:12px;"> (已下载{{choosePicMsg.downloadCount}}次)</span> </p>
            </div> -->
          </div>
        </div>

        <div ref="piclist"
             class="piclist">
          <div v-if="picAllListFlag >= 13 || scroll < -1"
               @click="smallLeft"
               class="leftjt">
            <i style="font-size: 30px"
               class="el-icon-arrow-left"></i>
          </div>

          <div ref="picalllist"
               style="display: flex; transition: 1s">
            <div @click="picListClick(e, i)"
                 v-for="(e, i) in notpicList"
                 :key="i">
              <!-- <img :src="e.src" :class="picAllListFlag === i || choosePicMsg.id === i ? 'picimg active':'picimg'" /> -->
              <div :style="{
                  backgroundImage: 'url(' + e.src + ')',
                  cursor: 'pointer',
                }"
                   @contextmenu.prevent="rightShow($event)"
                   ondragstart="return false;"
                   :class="
                  picAllListFlag === i || choosePicMsg.myId === i
                    ? 'picimg active'
                    : 'picimg'
                "></div>
            </div>
          </div>

          <div v-if="picCha !== scroll && notpicList.length > 13"
               @click="smallRight"
               class="rightjt">
            <i style="font-size: 30px"
               class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>

      <div class="right">
        <div class="title">
          <p>图片信息
            <span>【
              {{choosePicMsg.picStatus==0?'私密':choosePicMsg.picStatus==2?'审核中':choosePicMsg.picStatus==3?'公开':'未通过'}}】
            </span>
          </p>
        </div>
        <!-- <p><div class="key">用户名</div><div class="value">可爱无敌美少女</div></p> -->
        <div style="display: flex; margin-bottom: 14px; padding-left: 8px">
          <div style="width: 45px">上传者</div>
          ： <span>{{ choosePicMsg.createUserName }}</span>
        </div>
        <div style="display: flex; margin-bottom: 14px; padding-left: 8px">
          <div style="width: 58px">所属图集</div>
          ： <span>{{ choosePicMsg.altasName }}</span>
        </div>
        <div style="display: flex; margin-bottom: 14px; padding-left: 8px">
          <div style="width: 58px">拍摄时间</div>
          ： <span>{{ picExif.CreateAtMy || "无" }}</span>
        </div>
        <div style="display: flex; margin-bottom: 14px; padding-left: 8px">
          <div style="width: 58px">上传时间</div>
          ： <span>{{ picInfo.createAt || "无" }}</span>
        </div>
        <div style="display: flex; margin-bottom: 14px; padding-left: 8px">
          <div style="width: 58px">相机品牌</div>
          ： <span>{{ picExif.Make || "暂无" }}</span>
        </div>
        <div style="display: flex; margin-bottom: 14px; padding-left: 8px">
          <div style="width: 58px">图片尺寸</div>
          ： <span>{{ picInfo.picW }}*{{ picInfo.picH }}像素</span>
        </div>
        <div style="display: flex; margin-bottom: 14px; padding-left: 8px">
          <div style="width: 58px">图片大小</div>
          ： <span>{{ picInfo.fileSize }}MB</span>
        </div>
        <div style="display: flex; margin-bottom: 14px; padding-left: 8px">
          <div style="width: 58px">图片格式</div>
          ： <span>{{ picInfo.format }}</span>
        </div>
        <div v-if="picExif.ExposureTime"
             style="display: flex; margin-bottom: 14px; padding-left: 8px">
          <div style="width: 58px">曝光时间</div>
          ： <span>{{ picExif.ExposureTime }}秒</span>
        </div>
        <div v-if="!picExif.ExposureTime"
             style="display: flex; margin-bottom: 14px; padding-left: 8px">
          <div style="width: 58px">曝光时间</div>
          ： <span>暂无</span>
        </div>
        <div style="display: flex; margin-bottom: 14px; padding-left: 8px">
          <div style="width: 58px">ISO速度</div>
          ： <span>{{ picExif.ISOSpeedRatings || "暂无" }}</span>
        </div>
        <div style="display: flex; margin-bottom: 14px; padding-left: 8px">
          <div style="width: 58px">图片焦距</div>
          ： <span>{{ picExif.FocalLength || "暂无" }}</span>
        </div>

        <div style="margin-top: 25px"
             class="title"
             v-if="choosePicMsg.desc">
          <p>图片说明</p>
        </div>

        <p style="line-height: 26px; padding-left: 8px">
          {{ choosePicMsg.desc }}
        </p>

        <div style="margin-top: 25px"
             class="title"
             v-if="choosePicMsg.labels && !isSimple">
          <p>智能标签</p>
        </div>

        <div v-if="!isSimple"
             style="
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            width: 100%;
            margin-top: 10px;
          ">
          <div style="margin-left: 5px; margin-bottom: 5px"
               v-for="(e, i) in choosePicMsg.labels"
               :key="i">
            <el-tag>{{ e }}</el-tag>
          </div>
        </div>

        <div class="msg disflex"
             v-if="false">
          <div class="picmsg">
            <p>{{ choosePicMsg.shareCount }}</p>
            <div>浏览量</div>
            <img src="@/assets/picbrowse/see.png"
                 alt="" />
          </div>
          <div class="picmsg">
            <p>{{ choosePicMsg.pushCount }}</p>
            <div>推送量</div>
            <img src="@/assets/picbrowse/msgpush.png"
                 alt="" />
          </div>
          <div class="picmsg">
            <p>{{ choosePicMsg.downloadCount }}</p>
            <div>平台数</div>
            <img src="@/assets/picbrowse/platform.png"
                 alt="" />
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="peopleDialogVisible"
               width="30%"
               :before-close="handleClose">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>标记人物</div>
      </div>
      <el-form :model="faceRuleForm"
               v-loading="peopleLoading"
               :rules="faceRules"
               ref="faceRuleForm"
               label-width="100px"
               class="demo-ruleForm">
        <el-form-item label="人物分类："
                      prop="peopleClass">
          <el-select v-model="faceRuleForm.peopleClass"
                     style="width: 100%"
                     placeholder="请选择人物分类">
            <el-option v-for="item in peopleClass"
                       :key="item"
                       :label="item"
                       :value="item"
                       v-html="'<span style=color:#303030;>'+item+'</span>'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地区："
                      prop="region">
          <el-select v-model="faceRuleForm.region"
                     style="width: 100%"
                     placeholder="请选择地区">
            <el-option v-for="item in region"
                       :key="item"
                       :label="item"
                       :value="item"
                       v-html="'<span style=color:#303030;>'+item+'</span>'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名："
                      prop="name">
          <el-input v-model="faceRuleForm.name"
                    @input="myInput"></el-input>
        </el-form-item>
      </el-form>
      <div style="width: 90%; margin: 20px auto"
           v-if="faceInputFlag">
        <p style="margin-top: 30px; margin-bottom: 10px">
          注：如人物已存在，您可以通过输入姓名检索并合并
        </p>
        <el-table :data="faceData"
                  style="width: 100%"
                  border>
          <el-table-column prop="peopleName"
                           label="人物姓名"
                           :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-image style="
                  width: 22px;
                  height: 22px;
                  border-radius: 50%;
                  margin-left: 10px;
                "
                        :src="scope.row.peopleLogo"
                        :preview-src-list="[scope.row.peopleLogo]"></el-image>
              <span>{{ scope.row.peopleName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createUserInfo.name"
                           label="创建人">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <p @click="mergeFace(scope)"
                 style="color: #185ed3; cursor: pointer">
                合并
              </p>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   @click="beSure('faceRuleForm')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="clickFaceDialog"
               width="30%"
               :before-close="clickFaceDialogHandleClose">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>提示</div>
      </div>
      <el-radio v-model="seeOrUpdateFace"
                label="1">修改</el-radio>
      <el-radio v-model="seeOrUpdateFace"
                label="2">查看</el-radio>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="clickFaceDialogHandleClose">取 消</el-button>
        <el-button type="primary"
                   @click="clickFaceDialogFun">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog width="26%"
               :before-close="handleCloseUser"
               :visible.sync="dialogVisibleUser">

      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>推送至用户</div>
      </div>
      <el-form :model="userForm"
               ref="userForm"
               label-width="100px"
               :rules="userRules">
        <el-form-item label="标题："
                      prop="name">
          <el-input v-model="userForm.name"
                    placeholder="必填，2-10个字"></el-input>
        </el-form-item>
        <el-form-item label="选择用户："
                      prop="user">
          <!-- multiple -->
          <el-select :remote-method="selectUser"
                     remote
                     v-model="userForm.user"
                     filterable
                     style="width:100%;"
                     placeholder="请选择用户">
            <el-option style="width:100%;"
                       v-for="item in userList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id"
                       v-html="'<span style=color:#303030;>'+item.name+'</span>'">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div slot="label"
               class="labelclass">
            备注：
          </div>
          <el-input type="textarea"
                    :autosize="{ minRows: 7}"
                    v-model="userForm.note"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleCloseUser">取 消</el-button>
        <el-button type="primary"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   @click="submitUser('userForm')">提 交</el-button>
      </div>
    </el-dialog>

    <el-dialog width="26%"
               :before-close="handleCloseWork"
               :visible.sync="dialogVisibleWork">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>分享至工作圈</div>
      </div>
      <el-form :model="workForm"
               ref="workForm"
               label-width="110px"
               :rules="workRules">
        <el-form-item label="标题："
                      prop="name">
          <el-input v-model="workForm.name"
                    placeholder="必填，2-10个字"></el-input>
        </el-form-item>
        <el-form-item label="选择工作圈："
                      prop="work">
          <!-- multiple -->
          <el-select :remote-method="selectWork"
                     remote
                     v-model="workForm.work"
                     filterable
                     style="width:100%;"
                     placeholder="请选择工作圈">
            <el-option style="width:100%;"
                       v-for="item in workList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id"
                       v-html="'<span style=color:#303030;>'+item.name+'</span>'">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div slot="label"
               class="labelclass">
            备注：
          </div>
          <el-input type="textarea"
                    :autosize="{ minRows: 7}"
                    v-model="workForm.note"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleCloseWork">取 消</el-button>
        <el-button type="primary"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   @click="submitWork('workForm')">提 交</el-button>
      </div>
    </el-dialog>

    <el-dialog width="26%"
               :before-close="dfhandleClosePic"
               :visible.sync="dfdialogVisible">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>推送至东方网融媒体平台</div>
      </div>
      <el-form :model="dfmyform"
               ref="dfmyform"
               label-width="70px"
               :rules="dfrules">
        <!-- <el-form-item v-if="isSee" label="渠道名称：" prop="name">
            <el-input v-model="myform.name" placeholder="必填，2-10个字"></el-input>
          </el-form-item> -->
        <el-form-item label="标题："
                      prop="name">
          <el-input v-model="dfmyform.name"></el-input>
        </el-form-item>
        <el-form-item>
          <div slot="label"
               class="labelclass">
            备注：
          </div>
          <el-input type="textarea"
                    :autosize="{ minRows: 7}"
                    v-model="dfmyform.note"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleClosePic">取 消</el-button>
        <el-button type="primary"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   @click="dfsubmitPic('dfmyform')">提 交</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { listLib, listMyPowerLib } from "@/api/lib";
import { listUser } from "@/api/user";
import { getPictures } from "@/api/picture"
import { addPicturePackage, getPicturePackage } from "@/api/picturePackage";
import { getAtlasSonIds, generateIndexPic } from "@/api/atlas";
import { myPictureNeed } from "@/api/pictureNeed";
import { deletePicture, updatePicture } from "@/api/picture";
import { listAllowPushChannel } from "@/api/pushChannel";
import { powersObj, allowLib, allowPushChannel } from "@/constants/powers";
import { formatConversion } from "@/plugins/getdate";
import { searchAtlas, searchPicture } from "@/api/search";
import { setUserSetting, getUserSetting } from "@/api/config";
import { changedescdialog } from "@/components/index";
import { seePeopleFace } from "@/components/index";
import { picPrefix } from "@/constants/piccommon";
import { addPeople, getPeopleConstant, listPeople } from "@/api/people";
import { listPeopleFaceByFileId, setPeopleFaceAccess } from "@/api/peopleFace";
import { fullScreen, exitFullscreen, checkFull } from "@/plugins/fullScreen";

import { listWorkgroup } from "@/api/workgroup";


export default {
  components: { changedescdialog, seePeopleFace },
  computed: {
    ...mapGetters(["createUid"]),
  },
  data () {
    return {

      //推送至东方
      dfdialogVisible: false,
      dfmyform: {
        name: "",
        note: "",
        createUid: this.createUid,
        id: ''
      },
      dfrules: {
        name: [{ required: true, message: "请填写标题", trigger: "change" }],
      },

      //分享到工作圈
      dialogVisibleWork: false,
      shareAtlasId: 0,
      workForm: {
        name: "",
        work: "",
        createUid: this.createUid,
        note: ""
      },
      workRules: {
        name: [{ required: true, message: "请输入标题", trigger: "change" }],
        work: [{ required: true, message: "请选择工作圈", trigger: "change" }],
      },
      workList: [],


      interfaceFlag: true,
      //刷新加载
      searchLoading: false,
      loading: false,
      seeFull: false,
      showSureBtn: true,
      index: -1,
      faceInputFlag: false,
      peopleLoading: false,
      //图片浏览
      picInfo: {},
      picExif: {},
      imgLoading: false, //图片加载
      dialogVisible: false,
      isUpload: this.$store.state.user.isUpload,
      choosePicMsg: { isLove: false },
      picAllListFlag: -1,
      scroll: 0,
      picCha: -1,
      haslovechange: false,

      //权限
      powersObj,
      allowPushChannel,
      allowLib,

      row: 1,
      widthWithUP: "",

      //推送渠道
      pushdialogVisible: false,
      pushList: [],
      pushIndex: 0,
      template: "",
      pushChannelId: "",

      //推送至图片邀约
      mydialogVisible: false,
      myform: {
        name: "",
        note: "",
        createUid: this.createUid,
        id: "",
      },
      rules: {
        name: [{ required: true, message: "请选择模板", trigger: "change" }],
      },
      picInviteList: [],

      //图集间距
      atlasMargin: "",

      total: 0,
      pageSize: 15,
      page: 0,
      totalPic: 0,
      pageSizePic: 35,
      pagePic: 0,
      isAside: this.bus.val,
      showLoading: false,
      sortFlag: true,
      displayResolution: 0,
      isPic: false,
      picList: [],
      notpicList: [],
      belongPicList: [
        {
          id: 0,
          name: "全部",
        },
      ],
      belongPicFlag: 0,

      themeList: [
        {
          id: 0,
          name: "不限",
        },
        {
          id: "亲子活动",
          name: "亲子活动",
        },
        {
          id: "体育赛事",
          name: "体育赛事",
        },
        {
          id: "建设",
          name: "建设",
        },
        {
          id: "劳作",
          name: "劳作",
        },
        {
          id: "开会",
          name: "开会",
        },
        {
          id: "调研",
          name: "调研",
        },
        {
          id: "抗洪抢险",
          name: "抗洪抢险",
        },
        {
          id: "春节",
          name: "春节",
        },
        {
          id: "演讲",
          name: "演讲",
        },
        {
          id: "采访",
          name: "采访",
        },
      ],
      themeFlag: 0,
      environmentList: [
        {
          id: 0,
          name: "不限",
        },
        {
          id: "会场",
          name: "会场",
        },
        {
          id: "农田",
          name: "农田",
        },
        {
          id: "办公室",
          name: "办公室",
        },
        {
          id: "医院",
          name: "医院",
        },
        {
          id: "商超",
          name: "商超",
        },
        {
          id: "城市",
          name: "城市",
        },
        {
          id: "山川",
          name: "山川",
        },
        {
          id: "工厂",
          name: "工厂",
        },
        {
          id: "星空",
          name: "星空",
        },
        {
          id: "校园",
          name: "校园",
        },
        {
          id: "水源",
          name: "水源",
        },
        {
          id: "街道",
          name: "街道",
        },
      ],
      environmentFlag: 0,
      contributorList: [],
      contributor: "",
      associatedEvents: "",
      warehousingTime: "",
      face: "",
      size: "",
      selectInput: "",
      picId: "",
      themeId: "",
      environmentId: "",
      orderByTime: 0,
      orderByTimePic: 0,
      loveList: this.$store.state.user.loveList,
      timeStart: "",
      timeEnd: "",
      isRefresh: false,

      picPrefix,

      atlasId: "",

      picTimes: 1,
      picDeg: 0,

      //图片说明
      descdialogVisible: false,
      message: "",

      //是否展示人脸
      switechValue: false,
      faceLength: 0,
      imgPicHeight: 0,
      peopleDialogVisible: false,
      faceRuleForm: {
        peopleClass: "",
        region: "",
        name: "",
      },
      faceRules: {
        peopleClass: [
          { required: true, message: "请选择人物分类", trigger: "blur" },
        ],
        region: [{ required: true, message: "请选择地区", trigger: "blur" }],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
      },

      faceData: [
        {
          name: "",
          createname: "",
          peopleId: -1,
        },
      ],
      faceid: -1,
      region: [],
      peopleClass: [],

      //人脸搜索相关
      facePeopleList: [],
      BigfileId: -1,
      percent: -1,

      //鼠标右击
      rightMouseTop: 0,
      rightMouseLeft: 0,
      rightMouseFlag: false,

      clickFaceDialog: false, //点击人脸查看或修改
      seeOrUpdateFace: 0, //查看或者修改人脸
      nowPeopleInfo: "", //当前人脸信息


      //推送到用户
      dialogVisibleUser: false,

      userForm: {
        name: "",
        user: "",
        createUid: this.createUid,
        note: ""
      },
      userRules: {
        name: [{ required: true, message: "请输入标题", trigger: "change" }],
        user: [{ required: true, message: "请选择用户", trigger: "change" }],
      },
      userList: [],

      showMessageLeft: false,
      showMessageRight: false,
      showGifFlag: false
    };
  },
  watch: {
    "$store.state.user.loveList" (data) {
      this.loveList = data;
      // console.log(data)
    },
    "$store.state.user.bigImage" (newVal, oldVal) {
      // console.log(newVal, oldVal);
      this.listPeopleFaceByFileIdAsync(this.BigfileId);
    },
  },
  methods: {
    ...mapActions(["setLoveList"]),
    myformChange (val) {
      console.log(val);
      this.myform.name = val.title;
      this.myform.id = val.id;
    },
    //东方网推送
    //东方网融媒体平台关闭
    dfhandleClosePic () {
      this.$refs['dfmyform'].resetFields();
      this.dfdialogVisible = false;
    },

    //东方推送
    dfsubmitPic (form) {
      this.$refs[form].validate(valid => {
        if (valid) {

          this.userGetAtlasSonIdsAsync(this.atlasId, "push", this.dfmyform);

          this.dfdialogVisible = false
          this.$router.push('/shareAndPush/myPush')
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },




    //工作圈筛选
    selectWork (query) {
      let dataExa
      if (query !== '') {
        dataExa = { page: 0, pageSize: 20, keyword: query }
        this.listWorkgroupAsync(dataExa)
      } else {
        dataExa = { page: 0, pageSize: 20 }
        this.listWorkgroupAsync(dataExa)
      }
    },

    //获取工作圈列表
    async listWorkgroupAsync (val) {
      let { status, data, message, errors } = await listWorkgroup(val);
      if (status) {
        this.workList = data;

      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //分享
    handleCloseWork () {
      this.$refs['workForm'].resetFields();

      this.dialogVisibleWork = false
    },

    //分享到工作圈
    submitWork (form) {
      this.$refs[form].validate(async (valid) => {
        if (valid) {
          let { status, data, message } = await getAtlasSonIds(this.shareAtlasId);
          let picid = data.toString();
          let choosePicMsg = {
            createUid: this.createUid,
            packageType: 'share',
            pictureCount: data.length,
            pictureIds: picid,
            targetUid: 0,
            targetWorkgroupId: this.workForm.work,
            title: this.workForm.name,
            shareConfig: JSON.stringify({ pushChannelId: '', note: this.workForm.note })
          }

          this.addPicturePackageAsync(choosePicMsg)


          this.dialogVisibleWork = false
          setTimeout(() => {
            this.$router.push('/shareAndPush/myShare')
          }, 1500);
          this.$nextTick(() => {
            this.shareFlag = false
          })
          this.workForm = {}
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },


    //推送到个人
    handleCloseUser () {
      this.dialogVisibleUser = false;
    },

    submitUser (form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          this.userGetAtlasSonIdsAsync(this.atlasId, "push");
          this.dialogVisibleUser = false
          this.handleClosePush = false

          this.$nextTick(() => {
            this.$router.push('/shareAndPush/myPush')
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    //用户名筛选
    selectUser (query) {
      let dataExa
      if (query !== '') {
        dataExa = { userType: 0, keyword: query }
        this.listUserPushAsync(dataExa)
      } else {
        dataExa = { userType: 0 }
        this.listUserPushAsync(dataExa)
      }
    },

    //获取用户列表
    async listUserPushAsync (val) {
      let { status, data, message, errors } = await listUser(val);
      if (status) {
        this.userList = data;

      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //栏目切换（图片/图集）
    columnSwitch (val) {
      this.isPic = val;
      if (!val) {
        if (this.pagePic === 0) {
          for (let i = 0; i < 20; i++) {
            let nopic = {
              src: require("@/assets/house/grey.png"),
            };
            this.notpicList.push(nopic);
          }
          let labels = [];
          if (this.themeId == 0) {
            this.themeId = "";
          }
          if (this.environmentId == 0) {
            this.environmentId = "";
          }
          if (!this.environmentId && !this.themeId) {
            labels = null;
          } else {
            labels.push(this.themeId);
            labels.push(this.environmentId);
            labels = labels.join(',')
          }

          setTimeout(() => {
            //获取图片
            this.searchPictureAsync({
              createUid: this.contributor,
              keyword: this.selectInput,
              libId: this.picId,
              timeStart: this.timeStart,
              timeEnd: this.timeEnd,
              page: this.pagePic,
              pageSize: this.pageSizePic,
              orderByTime: this.orderByTimePic,
              peopleId: this.face,
              labels: labels
            });
          }, 1000);
        }
      }
    },

    //图片右击
    rightShow (e) {
      this.rightMouseLeft = e.clientX;
      this.rightMouseTop = e.clientY;
      setTimeout(() => {
        this.rightMouseFlag = true;
      }, 200);
      setTimeout(() => {
        this.rightMouseFlag = false;
      }, 2000);
      // this.$message('版权所有')
    },

    //人脸检索
    selectFacePeople (query) {
      let dataExa;
      if (query !== "") {
        dataExa = { page: 0, pageSize: 20, name: query, fuzzySearch: true };
        this.listPeopleSelectAsync(dataExa);
      } else {
        dataExa = { page: 0, pageSize: 20 };
        this.listPeopleSelectAsync(dataExa);
      }
    },
    async listPeopleSelectAsync (val) {
      let { status, data, message } = await listPeople(val);
      if (status) {
        this.facePeopleList = [];
        for (let i = 0; i < data.length; i++) {
          this.facePeopleList.push({
            value: data[i].id,
            label: data[i].peopleName,
          });
        }
      } else {
        this.$message.error("查询人物列表失败！");
      }
    },

    seeBigSmall () {
      // this.switechValue = false
      // this.seeFull = !this.seeFull
      this.$refs.imgPic.style.left = "";
      this.$refs.imgPic.style.top = "";
      this.picTimes = 1;
      this.picDeg = 0;
      this.$refs.imgPic.style.transform =
        "scale(" + this.picTimes + ") rotateZ(" + this.picDeg + "deg)";
      this.$store.commit("SET_BigImage", !this.$store.state.user.bigImage);
      if (this.$store.state.user.bigImage) {
        fullScreen(this.$refs.imgBj);
        this.seeFull = true;
      } else {
        exitFullscreen();
        this.seeFull = false;
      }
    },
    mergeFace (scope) {
      this.$confirm("确认合并吗?", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      }).then((es) => {
        let val = {
          faceId: this.faceid,
          peopleId: scope.row.id,
        };
        this.faceRuleForm.name = scope.row.peopleName;
        this.setPeopleFaceAccessAsync(val);
        this.clickFaceDialog = false;
      });
    },
    myInput (item) {
      let val;
      if (item.length >= 1) {
        this.faceInputFlag = true;
        val = {
          name: item,
          fuzzySearch: true,
        };
        this.listPeopleAsync(val);
      } else {
        this.faceInputFlag = false;
      }
    },
    async listPeopleAsync (val) {
      let { status, data, message } = await listPeople(val);
      if (status) {
        this.faceData = data;
        for (let i = 0; i < data.length; i++) {
          data[i].peopleLogo = picPrefix + data[i].peopleLogo;

          if (data[i].peopleName === this.faceRuleForm.name) {
            this.showSureBtn = false;
            console.log(1);
          } else {
            this.showSureBtn = true;
            console.log(2);
          }
          console.log(this.showSureBtn);
          console.log(data[i].peopleName, this.faceRuleForm.name);
        }
        if (data.length == 0) {
          this.showSureBtn = true;
        }
      }
    },

    clickFaceDialogHandleClose () {
      this.clickFaceDialog = false;
      this.seeOrUpdateFace = 0;
    },
    async clickFaceDialogFun () {
      //确认修改或者查看人脸
      if (this.seeOrUpdateFace == 1) {
        this.faceid = this.nowPeopleInfo.faceId;
        this.index = this.nowPeopleInfo.index;
        if (this.nowPeopleInfo.peopleName == "未设置") {
          this.peopleDialogVisible = true;
          this.getPeopleConstantAsync();
        } else {
          this.peopleDialogVisible = true;
          this.getPeopleConstantAsync();
        }
      } else if (this.seeOrUpdateFace == 2) {
        setTimeout(() => {
          this.$refs.seePeopleFace.getInfo(this.nowPeopleInfo);
        }, 200);
      } else {
        this.$message.warning("请选择修改或查看！");
      }
    },
    getFaceId (item, index) {
      this.clickFaceDialog = true;
      this.nowPeopleInfo = item;
      this.nowPeopleInfo.index = index;
      // this.faceid = item.faceId
      // this.index = index
      // if (item.peopleName == '未设置') {
      //   this.peopleDialogVisible = true
      //   this.getPeopleConstantAsync()
      // } else {
      //   this.$confirm('确认修改吗?', '', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消'
      //   }).then(() => {
      //     this.peopleDialogVisible = true
      //     this.getPeopleConstantAsync()
      //   }).catch(() => {
      //   });
      // }
    },
    beSure (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let val = {
            peopleClass: this.faceRuleForm.peopleClass,
            region: this.faceRuleForm.region,
            peopleName: this.faceRuleForm.name,
          };
          this.peopleLoading = true;
          this.addPeopleAsync(val);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async addPeopleAsync (val) {
      let { status, data, message, errors } = await addPeople(val);
      if (status) {
        let value = {
          faceId: this.faceid,
          peopleId: data.id,
        };
        // console.log(value);
        this.setPeopleFaceAccessAsync(value);
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
      this.peopleLoading = false;
    },
    async setPeopleFaceAccessAsync (val) {
      let { status, data, message, errors } = await setPeopleFaceAccess(val);
      if (status) {
        this.$message.success(message);
        this.peopleDialogVisible = false;
        // console.log(1);
        this.choosePicMsg.faceInfo[
          this.index
        ].peopleName = this.faceRuleForm.name;
        this.faceRuleForm = {};
        this.faceInputFlag = false;
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
        console.log(2);
      }
      this.peopleLoading = false;
    },
    async getPeopleConstantAsync () {
      let { status, data, message } = await getPeopleConstant();
      this.region = data.region;
      this.peopleClass = data.peopleClass;
    },

    handleClose () {
      this.faceRuleForm = {};
      this.faceData = {};
      this.faceInputFlag = false;
      this.peopleDialogVisible = false;
    },
    //修改图片说明
    changeDesc (val) {
      this.updatePictureAsync(val);
      this.descdialogVisible = false;
    },
    deschandleClose () {
      this.descdialogVisible = false;
    },
    openChangeDesc (val) {
      // console.log(val)
      this.message = val;
      this.descdialogVisible = true;
    },
    //修改图片说明
    async updatePictureAsync (val) {
      let { status, data, message, errors } = await updatePicture(val);
      if (status) {
        this.$message.success("修改成功！");
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //图片放大
    picLarge () {
      this.picTimes += 1.5;
      if (this.picTimes < 6) {
        this.$refs.imgPic.style.transform =
          "scale(" + this.picTimes + ") rotateZ(" + this.picDeg + "deg)";
      } else {
        this.picTimes = 6;
        this.$refs.imgPic.style.transform =
          "scale(6) rotateZ(" + this.picDeg + "deg)";
      }
    },
    //图片缩小
    picSmall () {
      this.picTimes -= 1.5;
      if (this.picTimes > 1) {
        this.$refs.imgPic.style.transform =
          "scale(" + this.picTimes + ") rotateZ(" + this.picDeg + "deg)";
      } else {
        this.picTimes = 1;
        this.$refs.imgPic.style.transform =
          "scale(1) rotateZ(" + this.picDeg + "deg)";
      }
    },

    //图片旋转
    picRotateLeft () {
      this.switechValue = false;
      this.picDeg -= 90;
      // if(this.picDeg >=360){
      //   this.picDeg = 0
      // }
      this.$refs.imgPic.style.transform =
        "scale(" + this.picTimes + ") rotateZ(" + this.picDeg + "deg)";
    },
    //图片旋转
    picRotateRight () {
      this.switechValue = false;
      this.picDeg += 90;
      // if(this.picDeg >=360){
      //   this.picDeg = 0
      // }
      this.$refs.imgPic.style.transform =
        "scale(" + this.picTimes + ") rotateZ(" + this.picDeg + "deg)";
    },
    //清除放大缩小效果
    clearLargeAndSmall () {
      this.$refs.imgPic.style.left = "";
      this.$refs.imgPic.style.top = "";
      this.picTimes = 1;
      this.picDeg = 0;
      this.$refs.imgPic.style.transform =
        "scale(" + this.picTimes + ") rotateZ(" + this.picDeg + "deg)";
    },

    //刷新表格
    refresh () {
      //清空人物筛选
      this.face = "";
      this.isRefresh = true;
      //清空所属资源库
      this.belongPicFlag = 0;
      //清空主题
      this.themeFlag = 0;
      //清空环境
      this.environmentFlag = 0;
      //清空投稿人
      this.contributor = "";
      //清空入库时间
      this.warehousingTime = "";
      //清空关键字
      this.selectInput = "";

      //按照图集为先
      // this.isPic = false;

      //清空排序
      this.orderByTime = 0;
      this.orderByTimePic = 0;
      this.sortFlag = true;

      //第一页开始
      this.page = 0;
      this.pagePic = 0;

      //获取图集
      this.searchAtlasAsync({
        pageSize: this.pageSize,
        page: this.page,
        orderByTime: this.orderByTime,
        status: 1
      });

      //获取图片
      this.searchPictureAsync({
        pageSize: this.pageSizePic,
        page: this.pagePic,
        orderByTime: this.orderByTimePic
      });

      setTimeout(() => {
        this.isRefresh = false;
      }, 888);
    },

    //推送渠道
    handleClosePush () {
      this.pushdialogVisible = false;
    },

    //图片邀约推送渠道
    quitPic () {
      this.mydialogVisible = false;
      // this.clearData()
    },
    handleClosePic () {
      this.mydialogVisible = false;
      // this.clearData()
    },
    submitPic (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          // console.log(1)
          this.getAtlasSonIdsAsync(this.atlasId, "push");
          setTimeout(() => {
            this.$router.push("/shareAndPush/myPush");
          }, 1000);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    //删除图片
    deletePic (item, index) {
      this.$confirm("确认删除吗？", {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then((e) => {
          if (index) {
            this.deletePictureAsync(item.id);
          } else {
            // console.log(this.choosePicMsg)
            this.deletePictureAsync(this.choosePicMsg.id);
          }
        })
        .catch((e) => {
          console.log("取消");
        });
    },

    //图集分享按钮
    shareClick (i) {
      this.$confirm("是否分享该图集？", {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then((e) => {
          this.getAtlasSonIdsAsync(i.id, "share", i);
          this.$router.push("/shareAndPush/myShare");
        })
        .catch((e) => {
          console.log("取消");
        });
    },
    downLoadPicAtlas (e) {
      //下载图集按钮
      this.$confirm("是否下载图集？", {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          this.getAtlasSonIdsAsync(e.id, "download", e);
        })
        .catch(() => { });
    },

    sharePicAtlas (e) {
      this.shareAtlasId = e.id
      this.dialogVisibleWork = true
      this.listWorkgroupAsync()
    },

    async getPicturePackageAsync (val) {
      let { status, data } = await getPicturePackage(val);
    },
    //图集推送按钮
    pushClick (i) {
      this.$confirm("是否推送该图集？", {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then((e) => {
          this.atlasId = i.id;
          this.listAllowPushChannelAsync();

          // this.listAtlasPicturesAsync(i.id)
          // this.getAtlasSonIdsAsync(i.id,'push',i)
        })
        .catch((e) => {
          console.log("取消");
        });
    },

    //推送选择
    choosePush (i, t, name, id) {
      this.pushIndex = i;
      this.template = t;
      this.pushChannelId = id;
      this.pushPic(name);
    },

    //图片包操作
    //推送
    pushPic (name) {
      if (this.template === "picture-website") {
        this.pushdialogVisible = false;
        this.$router.push({
          path: "/shareAndPush/push/show",
          query: {
            isSavePic: true,
            name: name,
            isDrawer: false,
            id: this.atlasId,
            pushChannelId: this.pushChannelId,
          },
        });
      } else if (this.template === "routersoft-qms") {
        this.pushdialogVisible = false;
        this.$router.push({
          path: "/shareAndPush/push/qms",
          query: {
            isSavePic: true,
            name: name,
            isDrawer: false,
            id: this.atlasId,
            pushChannelId: this.pushChannelId,
          },
        });
      } else if (
        this.template === "routersoft-rmt" ||
        this.template === "routersoft-mcp"
      ) {
        this.pushdialogVisible = false;
        this.$router.push({
          path: "/shareAndPush/push/mcp",
          query: {
            isSavePic: true,
            name: name,
            isDrawer: false,
            id: this.atlasId,
            pushChannelId: this.pushChannelId,
          },
        });
      } else if (
        this.template === "picture-need" ||
        this.template === "system-picture-need"
      ) {
        this.mydialogVisible = true;
        this.pushdialogVisible = false;
      } else if (this.template === 'picture-user') {
        this.dialogVisibleUser = true
        this.listUserPushAsync({ userType: 0 })
      } else if (this.template === "eastnet-mc") {
        this.dfdialogVisible = true
      }
    },

    //查看人脸
    seeFace () {
      this.switechValue = !this.switechValue;
      this.$refs.imgPic.style.left = "";
      this.$refs.imgPic.style.top = "";
      this.picTimes = 1;
      this.picDeg = 0;
      this.$refs.imgPic.style.transform =
        "scale(" + this.picTimes + ") rotateZ(" + this.picDeg + "deg)";
    },

    //添加选用图片
    lovePic (item, index) {
      if (index) {
        if (this.notpicList[index].errortext == "error") {
          this.$message.warning("图片生成失败，无法添加到选用图片!");
          return false;
        }
      } else if (index == 0) {
        if (this.notpicList[index].errortext == "error") {
          this.$message.warning("图片生成失败，无法添加到选用图片!");
          return false;
        }
      } else {
        if (this.notpicList[this.choosePicMsg.myId].errortext == "error") {
          this.$message.warning("图片生成失败，无法添加到选用图片!");
          return false;
        }
      }

      // console.log(item,index)
      let picLoveString = sessionStorage.getItem("picLove");
      let picLoveArray = JSON.parse(picLoveString);



      if (picLoveArray == null) {
        for (let i = 0; i < this.notpicList.length; i++) {
          this.notpicList[i].isLove = false;
        }
      } else {
        for (let j = 0; j < picLoveArray.length; j++) {
          for (let z = 0; z < this.notpicList.length; z++) {
            if (picLoveArray[j].id === this.notpicList[z].id) {
              this.notpicList[z].isLove = true;
            }
          }
        }
      }
      if (index || index == 0) {
        if (!item.isLove) {
          // if (picLoveArray !== null) {
          //   if (picLoveArray.length > 34) {
          //     this.$message.warning('选用图片最多35张!');
          //     return false
          //   }
          // }

          this.loveList.push(item.id);
          this.setLoveList(this.loveList);
          this.notpicList[index].isLove = true;
          if (!picLoveArray) {
            let pL = [];
            pL.push(item);
            sessionStorage.setItem("picLove", JSON.stringify(pL));
            this.setUserSettingAsync(this.createUid, "picLove", {
              value: item.id,
            });
            this.$message.success("添加成功");
          } else {
            picLoveArray.push(item);
            sessionStorage.setItem("picLove", JSON.stringify(picLoveArray));
            let idsInfo = []
            for (let k = 0; k < picLoveArray.length; k++) {
              idsInfo.push({
                id: picLoveArray[k].id,
              })
            }
            this.setUserSettingAsync(this.createUid, "picLove", {
              value: idsInfo,
            });
            this.$message.success("添加成功");
          }
        } else {
          this.loveList.splice(this.loveList.indexOf(item.id), 1);
          this.setLoveList(this.loveList);

          this.notpicList[index].isLove = false;

          if (picLoveArray.length === 1) {
            sessionStorage.removeItem("picLove");
            this.setUserSettingAsync(this.createUid, "picLove", {
              value: null,
            });
            this.$message.success("移除成功");
          } else {
            let f;
            for (let i = 0; i < picLoveArray.length; i++) {
              if (item.id === picLoveArray[i].id) {
                f = i;
              }
            }
            // console.log(picLoveArray)
            picLoveArray.splice(f, 1);
            sessionStorage.setItem("picLove", JSON.stringify(picLoveArray));
            let idsInfo = []
            for (let k = 0; k < picLoveArray.length; k++) {
              idsInfo.push({
                id: picLoveArray[k].id,
              })
            }
            this.setUserSettingAsync(this.createUid, "picLove", {
              value: idsInfo,
            });
            this.$message.success("移除成功");
          }
        }
      } else {
        if (!this.choosePicMsg.isLove) {
          this.loveList.push(this.choosePicMsg.id);
          this.setLoveList(this.loveList);
          this.choosePicMsg.isLove = true;

          this.haslovechange = true;

          if (!picLoveArray) {
            let pL = [];
            pL.push(this.choosePicMsg);
            sessionStorage.setItem("picLove", JSON.stringify(pL));
            this.$message.success("添加成功");
          } else {
            picLoveArray.push(this.choosePicMsg);
            sessionStorage.setItem("picLove", JSON.stringify(picLoveArray));
            this.$message.success("添加成功");
          }
        } else {
          this.loveList.splice(this.loveList.indexOf(this.choosePicMsg.id), 1);
          this.setLoveList(this.loveList);

          this.choosePicMsg.isLove = false;

          this.haslovechange = false;

          if (picLoveArray.length === 1) {
            sessionStorage.removeItem("picLove");
            this.$message.success("移除成功");
          } else {
            let f;
            for (let i = 0; i < picLoveArray.length; i++) {
              if (this.choosePicMsg.id === picLoveArray[i].id) {
                f = i;
              }
            }
            // console.log(picLoveArray)
            picLoveArray.splice(f, 1);
            sessionStorage.setItem("picLove", JSON.stringify(picLoveArray));
            this.$message.success("移除成功");
          }
        }
      }

      // console.log(picLoveArray,item)
    },

    //清空搜索框数据
    clearValue () {
      this.contributor = "";
      this.warehousingTime = "";
      this.belongPicFlag = 0;
      this.selectInput = "";
    },

    //排序
    sortClick () {
      this.sortFlag = !this.sortFlag;
      this.page = 0;
      this.pagePic = 0;
      if (this.orderByTime === 0) {
        this.orderByTime = 1;
      } else {
        this.orderByTime = 0;
      }

      if (this.orderByTimePic === 0) {
        this.orderByTimePic = 1;
      } else {
        this.orderByTimePic = 0;
      }

      let labels = [];
      if (this.themeId == 0) {
        this.themeId = "";
      }
      if (this.environmentId == 0) {
        this.environmentId = "";
      }
      if (!this.environmentId && !this.themeId) {
        labels = null;
      } else {
        labels.push(this.themeId);
        labels.push(this.environmentId);

        labels = labels.join(',')
      }


      let params = {
        createUid: this.contributor,
        keyword: this.selectInput,
        libId: this.picId,
        timeStart: this.timeStart,
        timeEnd: this.timeEnd,
        page: this.page,
        pageSize: this.pageSize,
        orderByTime: this.orderByTime,
        status: 1,
        peopleId: this.face
      };

      let paramspic = {
        createUid: this.contributor,
        keyword: this.selectInput,
        libId: this.picId,
        timeStart: this.timeStart,
        timeEnd: this.timeEnd,
        page: this.pagePic,
        pageSize: this.pageSizePic,
        orderByTime: this.orderByTimePic,
        peopleId: this.face,
        labels: labels
      };
      this.searchAtlasAsync(params);
      this.searchPictureAsync(paramspic);
    },

    picClick (i, id) {
      this.belongPicFlag = i;
      this.picId = id;

      this.notpicList = []
      this.searchLoading = true

      this.searchClick();
    },

    themeClick (i, id) {
      this.themeFlag = i;
      this.themeId = id;

      this.notpicList = []
      this.searchLoading = true

      this.searchClick();
    },

    environmentClick (i, id) {
      this.environmentFlag = i;
      this.environmentId = id;

      this.notpicList = []
      this.searchLoading = true

      this.searchClick();
    },

    searchClick () {
      this.showGifFlag = true
      if (this.warehousingTime[0]) {
        this.timeStart = this.warehousingTime[0] / 1000;
        this.timeEnd = this.warehousingTime[1] / 1000;
      } else {
        this.timeStart = "";
        this.timeEnd = "";
      }

      if (this.belongPicFlag === 0) {
        this.picId = "";
      }

      let labels = [];
      if (this.themeId == 0) {
        this.themeId = "";
      }
      if (this.environmentId == 0) {
        this.environmentId = "";
      }
      if (!this.environmentId && !this.themeId) {
        labels = null;
      } else {
        labels.push(this.themeId);
        labels.push(this.environmentId);

        labels = labels.join(',')
      }


      this.pagePic = 0;
      this.page = 0;
      this.orderByTime = 0;
      this.orderByTimePic = 0;
      let params = {
        createUid: this.contributor,
        keyword: this.selectInput,
        libId: this.picId,
        timeStart: this.timeStart,
        timeEnd: this.timeEnd,
        page: this.page,
        pageSize: this.pageSize,
        orderByTime: this.orderByTime,
        status: 1,
        peopleId: this.face
      };
      let paramspic = {
        createUid: this.contributor,
        keyword: this.selectInput,
        libId: this.picId,
        timeStart: this.timeStart,
        timeEnd: this.timeEnd,
        page: this.pagePic,
        pageSize: this.pageSizePic,
        orderByTime: this.orderByTimePic,
        peopleId: this.face,
        labels: labels
      };
      // this.clearValue();
      this.searchAtlasAsync(params);
      this.searchPictureAsync(paramspic);
    },

    intoPicList (id) {
      this.$router.push({
        //核心语句
        name: "pictureCenterAtlasShow", //跳转的路径
        query: {
          //路由传参时push和query搭配使用 ，作用时传递参数
          id: id,
        },
      });
    },

    //图片浏览事件

    //判断选中的图片在什么位置
    beSurePic (i, num) {
      if (i > num) {
        let picalllistwidth = this.$refs.picalllist.offsetWidth;
        let piclistwidth = this.$refs.piclist.offsetWidth;
        this.scroll = i * -80;
        // console.log(piclistwidth - picalllistwidth)
        // console.log(this.scroll)
        if (this.scroll < piclistwidth - picalllistwidth) {
          this.scroll = piclistwidth - picalllistwidth - 70;
          this.picCha = this.scroll;
        }
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      } else {
        this.$refs.picalllist.style.transform = "translateX(" + 0 + ")";
        this.scroll = 0;
      }
    },
    //获取图片信息
    getPicInfo (e) {
      this.picInfo.picH = e.fileInfo.picH || "1920";
      this.picInfo.picW = e.fileInfo.picW || "1080";
      this.picInfo.format =
        e.fileInfo.savepath.substring(e.fileInfo.savepath.length - 3) || "jpg";
      this.picInfo.createAt = formatConversion(
        e.fileInfo.createAt.toString()
      ).substring(0, 10);
      this.picInfo.fileSize =
        (e.fileInfo.fileSize / 1024 / 1024).toFixed(2) || "暂无";
        console.log(e);

      if (e.exif) {
        console.log(e.exif);
        this.picExif = e.exif;
        if (e.exif.CreateAt) {
          this.picExif.CreateAtMy = formatConversion(
            this.picExif.CreateAt.toString()
          ).substring(0, 10);
        } else {
          this.picExif.CreateAtMy = null;
        }
      }
      this.BigfileId = e.fileId;
      this.listPeopleFaceByFileIdAsync(e.fileId);
    },

    openUpload () {
      this.setIsUpload(false);
    },
    closeUpload () {
      this.setIsUpload(true);
    },
    openDialog (i, e) {
      // console.log(this.switechValue);
      this.switechValue = false;
      // console.log(this.switechValue);
      this.dialogVisible = true;
      this.choosePicMsg = { isLove: false };

      this.choosePicMsg.fileId = e.fileId;
      // e.labels=['风景','运动员','环境','劳作','亲子活动','开会','抗洪抢险','剪裁']
      this.choosePicMsg.id = e.id;
      this.choosePicMsg.labels = e.labels;
      this.choosePicMsg.desc = e.desc;
      this.choosePicMsg.downloadCount = e.downloadCount;
      this.choosePicMsg.pushCount = e.pushCount;
      this.choosePicMsg.shareCount = e.shareCount;
      this.choosePicMsg.errortext = "";
      if (e.errortext) {
        this.choosePicMsg.errortext = e.errortext;
      }
      this.choosePicMsg.src = e.srcW1080;
      this.choosePicMsg.srcW1080 = e.srcW1080;
      if (e.createUserInfo) {
        this.choosePicMsg.createUserName = e.createUserInfo.name;
      } else {
        this.choosePicMsg.createUserName = "暂无";
      }
      if (e.atlasInfo) {
        this.choosePicMsg.altasName = e.atlasInfo.name;
      } else {
        this.choosePicMsg.altasName = "暂无";
      }

      this.choosePicMsg.myId = i;

      this.picAllListFlag = i;

      let picLoveString = sessionStorage.getItem("picLove");
      let picLoveArray = JSON.parse(picLoveString);

      this.choosePicMsg.isLove = false;
      this.haslovechange = false;
      if (picLoveArray !== null) {
        for (let j = 0; j < picLoveArray.length; j++) {
          if (picLoveArray[j].id === this.choosePicMsg.id) {
            this.choosePicMsg.isLove = true;
            this.haslovechange = true;
          }
        }
      }

      // let faceInfo = await listPeopleFaceByFileId({ fileId: this.choosePicMsg.fileId })
      // let faceCoord = faceInfo.data

      this.getPicInfo(e);

      this.$nextTick(() => {
        this.imgPicHeight = this.$refs.imgPic.clientHeight || 279;
        this.clearLargeAndSmall();
        this.beSurePic(i, 10);
      });

      setTimeout(() => {
        this.BigfileId = e.fileId;
        this.listPeopleFaceByFileIdAsync(e.fileId);
      }, 1000);
    },
    async listPeopleFaceByFileIdAsync (fileId) {
      if (this.$store.state.user.bigImage) {
        this.percent = this.picInfo.picH / window.screen.height;
      } else {
        this.percent = this.picInfo.picH / this.imgPicHeight;
      }
      console.log(this.$store.state.user.bigImage, this.imgPicHeight);
      let { data, message, status } = await listPeopleFaceByFileId({
        fileId: fileId,
      });
      // console.log(this.$refs.imgPic.clientHeight, this.$refs.imgPic.clientWidth);
      // console.log(fileInfo.picH, fileInfo.picW);
      if (status) {
        this.choosePicMsg.faceInfo = [];
        this.faceLength = data.length;
        this.$forceUpdate();
        for (let i = 0; i < data.length; i++) {
          this.faceArr = {};
          let coordArr = data[i].coord.split(",");
          coordArr[0] = Math.round(
            parseFloat(coordArr[0]) * (this.picInfo.picH / this.percent)
          );
          coordArr[1] = Math.round(
            parseFloat(coordArr[1]) * (this.picInfo.picW / this.percent)
          );
          coordArr[2] = Math.round(
            parseFloat(coordArr[2]) * (this.picInfo.picH / this.percent)
          );
          coordArr[3] = Math.round(
            parseFloat(coordArr[3]) * (this.picInfo.picW / this.percent)
          );
          // console.log(coordArr);
          this.faceArr.width = coordArr[1] - coordArr[3];
          this.faceArr.height = coordArr[2] - coordArr[0];
          this.faceArr.top = Math.round(
            coordArr[0] - this.picInfo.picH / this.percent / 2
          );
          this.faceArr.left = Math.round(
            coordArr[3] - this.picInfo.picW / this.percent / 2
          );
          this.faceArr.faceId = data[i].id;
          this.faceArr.peopleId = data[i].peopleId;
          if (data[i].peopleInfo === null) {
            this.faceArr.peopleName = "未设置";
          } else {
            this.faceArr.peopleName = data[i].peopleInfo.peopleName;
          }
          this.choosePicMsg.faceInfo.push(this.faceArr);
          this.$forceUpdate();
        }
        // console.log(this.choosePicMsg.faceInfo);
      }
    },
    async picListClick (e, i) {
      this.clearLargeAndSmall();
      this.choosePicMsg.fileId = e.fileId;
      this.choosePicMsg.id = e.id;
      this.choosePicMsg.labels = e.labels;
      this.choosePicMsg.desc = e.desc;
      this.choosePicMsg.downloadCount = e.downloadCount;
      this.choosePicMsg.pushCount = e.pushCount;
      this.choosePicMsg.shareCount = e.shareCount;
      this.choosePicMsg.errortext = "";
      if (e.errortext) {
        this.choosePicMsg.errortext = e.errortext;
      }
      this.choosePicMsg.src = e.srcW1080;
      this.choosePicMsg.srcW1080 = e.srcW1080;
      if (e.createUserInfo) {
        this.choosePicMsg.createUserName = e.createUserInfo.name;
      } else {
        this.choosePicMsg.createUserName = "暂无";
      }
      if (e.atlasInfo) {
        this.choosePicMsg.altasName = e.atlasInfo.name;
      } else {
        this.choosePicMsg.altasName = "暂无";
      }
      this.choosePicMsg.faceInfo = [];
      this.choosePicMsg.myId = i;
      this.picAllListFlag = i;

      let picLoveString = sessionStorage.getItem("picLove");
      let picLoveArray = JSON.parse(picLoveString);

      this.choosePicMsg.isLove = false;
      this.haslovechange = false;
      if (picLoveArray !== null) {
        for (let j = 0; j < picLoveArray.length; j++) {
          if (picLoveArray[j].id === this.choosePicMsg.id) {
            this.choosePicMsg.isLove = true;
            this.haslovechange = true;
          }
        }
      }

      this.getPicInfo(e);
    },

    //图片浏览中大的箭头 左边
    async bigLeft () {
      if (this.choosePicMsg.myId === 0) {
        if (!this.showMessageLeft) {
          this.showMessageLeft = true
          setTimeout(() => {
            this.showMessageLeft = false
          }, 1500);
        }
        return;
      }
      // if(this.choosePicMsg.id === this.picList.length - 1){
      //   return
      // }
      this.clearLargeAndSmall();
      this.choosePicMsg.errortext = "";
      if (this.notpicList[this.choosePicMsg.myId - 1].errortext) {
        this.choosePicMsg.errortext = this.notpicList[
          this.choosePicMsg.myId - 1
        ].errortext;
      }
      this.choosePicMsg.fileId = this.notpicList[
        this.choosePicMsg.myId - 1
      ].fileId;
      this.choosePicMsg.labels = this.notpicList[
        this.choosePicMsg.myId - 1
      ].labels;
      this.choosePicMsg.src = this.notpicList[
        this.choosePicMsg.myId - 1
      ].srcW1080;
      this.choosePicMsg.srcW1080 = this.notpicList[
        this.choosePicMsg.myId - 1
      ].srcW1080;
      this.choosePicMsg.desc = this.notpicList[this.choosePicMsg.myId - 1].desc;
      this.choosePicMsg.downloadCount = this.notpicList[
        this.choosePicMsg.myId - 1
      ].downloadCount;
      this.choosePicMsg.pushCount = this.notpicList[
        this.choosePicMsg.myId - 1
      ].pushCount;
      this.choosePicMsg.shareCount = this.notpicList[
        this.choosePicMsg.myId - 1
      ].shareCount;
      this.choosePicMsg.id = this.notpicList[this.choosePicMsg.myId - 1].id;
      if (this.notpicList[this.choosePicMsg.myId - 1].createUserInfo) {
        this.choosePicMsg.createUserName = this.notpicList[
          this.choosePicMsg.myId - 1
        ].createUserInfo.name;
      } else {
        this.choosePicMsg.createUserName = "暂无";
      }
      if (this.notpicList[this.choosePicMsg.myId - 1].atlasInfo) {
        this.choosePicMsg.altasName = this.notpicList[
          this.choosePicMsg.myId - 1
        ].atlasInfo.name;
      } else {
        this.choosePicMsg.altasName = "暂无";
      }
      this.choosePicMsg.faceInfo = [];
      let picLoveString = sessionStorage.getItem("picLove");
      let picLoveArray = JSON.parse(picLoveString);

      this.choosePicMsg.isLove = false;
      this.haslovechange = false;
      if (picLoveArray !== null) {
        for (let j = 0; j < picLoveArray.length; j++) {
          if (picLoveArray[j].id === this.choosePicMsg.id) {
            this.choosePicMsg.isLove = true;
            this.haslovechange = true;
          }
        }
      }

      this.getPicInfo(this.notpicList[this.choosePicMsg.myId - 1]);

      this.choosePicMsg.myId = this.choosePicMsg.myId - 1;
      // console.log(this.choosePicMsg)
      this.picAllListFlag = this.choosePicMsg.myId;
      if (this.choosePicMsg.myId < 10) {
        this.scroll = 0;
        this.picCha = -1;
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      } else {
        this.scroll = this.scroll + 3 * this.choosePicMsg.myId;
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      }
      console.log(
        this.choosePicMsg.fileId,
        this.notpicList[this.choosePicMsg.myId - 1]
      );
      this.BigfileId = this.choosePicMsg.fileId;
      this.listPeopleFaceByFileIdAsync(this.choosePicMsg.fileId);
    },
    //图片浏览中大的箭头 右边
    async bigRight () {
      if (this.choosePicMsg.myId === this.notpicList.length - 1) {
        if (!this.showMessageRight) {
          this.showMessageRight = true
          setTimeout(() => {
            this.showMessageRight = false
          }, 1500);
        }
        return;
      }
      // this.picListClick(this.picList[this.choosePicMsg.id + 1],this.choosePicMsg.id + 1)
      this.clearLargeAndSmall();
      this.choosePicMsg.errortext = "";
      if (this.notpicList[this.choosePicMsg.myId + 1].errortext) {
        this.choosePicMsg.errortext = this.notpicList[
          this.choosePicMsg.myId + 1
        ].errortext;
      }
      this.choosePicMsg.fileId = this.notpicList[
        this.choosePicMsg.myId + 1
      ].fileId;
      this.choosePicMsg.labels = this.notpicList[
        this.choosePicMsg.myId + 1
      ].labels;
      this.choosePicMsg.src = this.notpicList[
        this.choosePicMsg.myId + 1
      ].srcW1080;
      this.choosePicMsg.srcW1080 = this.notpicList[
        this.choosePicMsg.myId + 1
      ].srcW1080;
      this.choosePicMsg.desc = this.notpicList[this.choosePicMsg.myId + 1].desc;
      this.choosePicMsg.downloadCount = this.notpicList[
        this.choosePicMsg.myId + 1
      ].downloadCount;
      this.choosePicMsg.pushCount = this.notpicList[
        this.choosePicMsg.myId + 1
      ].pushCount;
      this.choosePicMsg.shareCount = this.notpicList[
        this.choosePicMsg.myId + 1
      ].shareCount;
      this.choosePicMsg.id = this.notpicList[this.choosePicMsg.myId + 1].id;
      if (this.notpicList[this.choosePicMsg.myId + 1].createUserInfo) {
        this.choosePicMsg.createUserName = this.notpicList[
          this.choosePicMsg.myId + 1
        ].createUserInfo.name;
      } else {
        this.choosePicMsg.createUserName = "暂无";
      }
      if (this.notpicList[this.choosePicMsg.myId + 1].atlasInfo) {
        this.choosePicMsg.altasName = this.notpicList[
          this.choosePicMsg.myId + 1
        ].atlasInfo.name;
      } else {
        this.choosePicMsg.altasName = "暂无";
      }
      this.choosePicMsg.faceInfo = [];
      let picLoveString = sessionStorage.getItem("picLove");
      let picLoveArray = JSON.parse(picLoveString);

      this.choosePicMsg.isLove = false;
      this.haslovechange = false;
      if (picLoveArray !== null) {
        for (let j = 0; j < picLoveArray.length; j++) {
          if (picLoveArray[j].id === this.choosePicMsg.id) {
            this.choosePicMsg.isLove = true;
            this.haslovechange = true;
          }
        }
      }

      this.getPicInfo(this.notpicList[this.choosePicMsg.myId + 1]);

      this.choosePicMsg.myId = this.choosePicMsg.myId + 1;

      this.picAllListFlag = this.choosePicMsg.myId;
      // console.log(this.choosePicMsg)
      if (this.choosePicMsg.myId > 10) {
        let picalllistwidth = this.$refs.picalllist.offsetWidth;
        let piclistwidth = this.$refs.piclist.offsetWidth;
        // console.log(this.scroll)
        // console.log(this.choosePicMsg.myId)
        if (this.scroll === 0) {
          this.scroll = this.choosePicMsg.myId * -70;
        } else {
          if (this.choosePicMsg.myId > 50) {
            this.scroll = this.scroll - 2 * this.choosePicMsg.myId;
          } else {
            this.scroll = this.scroll - 3 * this.choosePicMsg.myId;
          }
        }
        if (this.scroll < piclistwidth - picalllistwidth) {
          this.scroll = piclistwidth - picalllistwidth - 80;
          setTimeout(() => {
            this.picCha = this.scroll;
          }, 1000);
        }
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      }
    },

    //图片浏览小的箭头 右边
    smallRight () {
      let picalllistwidth = this.$refs.picalllist.offsetWidth;
      let piclistwidth = this.$refs.piclist.offsetWidth;
      this.scroll = this.scroll - 300;
      if (this.scroll < piclistwidth - picalllistwidth) {
        this.scroll = piclistwidth - picalllistwidth - 70;
        this.picCha = this.scroll;
        // console.log(this.scroll)
      }

      this.$refs.picalllist.style.transform =
        "translateX(" + this.scroll + "px)";

      // console.log(this.scroll)
    },
    //图片浏览小的箭头 左边
    smallLeft () {
      // let picalllistwidth = this.$refs.picalllist.offsetWidth
      // let piclistwidth = this.$refs.piclist.offsetWidth
      this.scroll = this.scroll + 300;
      if (this.scroll > 0) {
        this.$refs.picalllist.style.transform = "translateX(" + 0 + "px)";
        this.scroll = 0;
      } else {
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      }

      // console.log(this.scroll)
    },

    //滚动加载图库和图片
    scrollPic () {
      let bottomOfWindow =
        document.documentElement.offsetHeight -
        document.documentElement.scrollTop -
        window.innerHeight <=
        1;
      let isBottom =
        document.documentElement.scrollTop + window.innerHeight + 50 >=
        document.body.offsetHeight;

      //变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      //变量windowHeight是可视区的高度
      var windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      // console.log(document.documentElement.scrollTop + window.innerHeight, document.body.offsetHeight);
      // var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      // var windowHeitht = document.documentElement.clientHeight || document.body.clientHeight;
      // var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      // console.log(scrollTop + windowHeitht >= scrollHeight - 50)
      // console.log(scrollTop, windowHeight, scrollHeight);
      if (scrollTop + windowHeight + 5 >= scrollHeight && this.interfaceFlag) {
        this.interfaceFlag = false
        //
        if (this.isPic) {

          if (this.picList.length !== this.total) {
            this.showLoading = true;
            setTimeout(() => {
              this.page++;
              // console.log(this.page)
              this.showLoading = false;
              let params = {
                createUid: this.contributor,
                keyword: this.selectInput,
                libId: this.picId,
                timeStart: this.timeStart,
                timeEnd: this.timeEnd,
                page: this.page,
                pageSize: this.pageSize,
                orderByTime: this.orderByTime,
                status: 1,
                peopleId: this.face
              };
              this.searchAtlasAsync(params);
              // console.log(this.picList)
            }, 1000);
          }
        } else {

          let labels = [];
          if (this.themeId == 0) {
            this.themeId = "";
          }
          if (this.environmentId == 0) {
            this.environmentId = "";
          }
          if (!this.environmentId && !this.themeId) {
            labels = null;
          } else {
            labels.push(this.themeId);
            labels.push(this.environmentId);

            labels = labels.join(',')
          }

          if (this.notpicList.length !== this.totalPic) {
            // console.log(this.notpicList.length, this.totalPic);
            this.showLoading = true;
            setTimeout(() => {
              this.pagePic++;

              let paramspic = {
                createUid: this.contributor,
                keyword: this.selectInput,
                libId: this.picId,
                timeStart: this.timeStart,
                timeEnd: this.timeEnd,
                page: this.pagePic,
                pageSize: this.pageSizePic,
                orderByTime: this.orderByTimePic,
                peopleId: this.face,
                labels: labels
              };
              this.searchPictureAsync(paramspic);
            }, 1000);
          }
        }
      }
    },

    //设置选用图片
    async setUserSettingAsync (val, val2, data1) {
      let { status, data, message, errors } = await setUserSetting(
        val,
        val2,
        data1
      );
      if (status) {
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取选用图片
    async getUserSettingAsync (val, val2) {
      let { status, data, message, errors } = await getUserSetting(val, val2);
      if (status) {
        let piclove = JSON.parse(data);
        // console.log(piclove);
        if (piclove.value == null) {
          sessionStorage.removeItem("picLove");
        } else {

          let picIds = []
          for (let i = 0; i < piclove.value.length; i++) {
            picIds.push(piclove.value[i].id)
          }
          picIds = picIds.join(',');
          // console.log(picIds);
          let idsInfo = await getPictures({ ids: picIds });
          console.log(idsInfo.data);
          for (let j = 0; j < idsInfo.data.length; j++) {
            idsInfo.data[j].srcW1080 = this.picPrefix + idsInfo.data[j].fileInfo.picThumbW1080
            idsInfo.data[j].src = this.picPrefix + idsInfo.data[j].fileInfo.picThumbH160
          }
          // console.log(idsInfo.data);
          sessionStorage.setItem("picLove", JSON.stringify(idsInfo.data));
        }
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取图片列表
    async listLibAsync () {
      let { status, data, message, pagination } = await listMyPowerLib();
      if (status) {
        for (let i = 0; i < data.length; i++) {
          if (this.allowLib.indexOf(data[i].id.toString()) !== -1) {
            if (data[i].status === 1) {
              this.belongPicList.push({
                id: data[i].id,
                name: data[i].name,
              });
            }
          }
        }
      }
    },

    //获取用户列表
    async listUserAsync () {
      let { status, data, message, pagination } = await listUser({
        pageSize: 10000,
      });
      if (status) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].status === 1) {
            if (data[i].userType === 0) {
              this.contributorList.push({
                value: data[i].id,
                label: data[i].name,
              });
            }
          }
        }
      }
    },

    //获取图集中图片的编号
    async getAtlasSonIdsAsync (val, type, e) {
      let { status, data, message } = await getAtlasSonIds(val);
      if (status) {
        // console.log(data)
        let id = data.toString();
        // console.log(id)
        let choosePicMsg = {
          createUid: this.createUid,
          packageType: type,
          pictureCount: data.length,
          pictureIds: id,
          targetUid: 0,
          title: e ? e.name : this.myform.name,
          pushConfig: JSON.stringify({
            pushChannelId: this.pushChannelId,
            pictureNeedId: this.myform.id,
            note: this.myform.note,
          }),
        };

        this.addPicturePackageAsync(choosePicMsg);
      } else {
        this.$message.error("失败！");
        this.mydialogVisible = false;
        this.pushdialogVisible = false;
      }
    },

    //获取图集中图片的编号
    async userGetAtlasSonIdsAsync (val, type, e) {
      let { status, data, message } = await getAtlasSonIds(val);
      if (status) {
        // console.log(data)
        let id = data.toString();
        // console.log(id)
        let choosePicMsg = {
          createUid: this.createUid,
          packageType: type,
          pictureCount: data.length,
          pictureIds: id,
          targetUid: this.userForm.user || 0,
          title: e ? e.name : this.userForm.name,
          pushConfig: JSON.stringify({
            pushChannelId: this.pushChannelId,
            note: e.note || '',
          }),
        };

        this.addPicturePackageAsync(choosePicMsg);
      } else {
        this.$message.error("失败！");
        this.mydialogVisible = false;
        this.pushdialogVisible = false;
      }
    },

    //删除图片
    async deletePictureAsync (val) {
      let { status, data, message, errors } = await deletePicture(val);
      if (status) {
        this.$message.success("删除成功！");
        this.dialogVisible = false;
        let labels = [];
        if (this.themeId == 0) {
          this.themeId = "";
        }
        if (this.environmentId == 0) {
          this.environmentId = "";
        }
        if (!this.environmentId && !this.themeId) {
          labels = null;
        } else {
          labels.push(this.themeId);
          labels.push(this.environmentId);
          labels = labels.join(',')
        }
        let paramspic = {
          createUid: this.contributor,
          keyword: this.selectInput,
          libId: this.picId,
          timeStart: this.timeStart,
          timeEnd: this.timeEnd,
          page: this.pagePic,
          pageSize: this.pageSizePic,
          orderByTime: this.orderByTimePic,
          labels: labels
        };
        this.searchPictureAsync(paramspic);
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取图片邀约列表
    async listPictureNeedAsync (val) {
      let { status, data, message, pagination, errors } = await myPictureNeed(
        val
      );
      if (status) {
        this.picInviteList = data;

        this.myform.name = this.picInviteList[0].title;
        this.myform.id = this.picInviteList[0].id;
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取允许的推送渠道
    async listAllowPushChannelAsync () {
      let { status, data, message, errors } = await listAllowPushChannel();
      if (status) {
        this.pushList = data;
        // this.allowPushChannel.push('0')

        // for (let i = 0; i < this.pushList.length; i++) {
        //   for (let j = 0; j < this.allowPushChannel.length; j++) {

        //   }
        // }
        this.template = this.pushList[0].template;
        this.pushdialogVisible = true;
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //增加图片包
    async addPicturePackageAsync (val) {
      let { status, data, message, errors } = await addPicturePackage(val);
      if (status) {
        this.$message.success("创建成功！");
        this.mydialogVisible = false;
        this.pushdialogVisible = false;
        // this.setDrawer(false)
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
        this.mydialogVisible = false;
        this.pushdialogVisible = false;
      }
    },

    //检索图集
    async searchAtlasAsync (val) {
      let { status, data, message, pagination, errors } = await searchAtlas(
        val
      );
      this.loading = false;
      if (status) {
        if (this.page === 0) {
          this.picList = data;
        } else {
          for (let i = 0; i < data.length; i++) {
            this.picList.push(data[i]);
          }
        }
        if (this.picList.length == 0) {
          this.row = 1;
        } else {
          this.checkRow();
        }
        this.total = pagination.total;
        for (let i = 0; i < this.picList.length; i++) {
          this.picList[i].mycreateAt = formatConversion(
            this.picList[i].createAt.toString()
          );

          if (
            this.picList[i].posterPath == "" &&
            this.picList[i].pictureCount !== 0
          ) {
            await generateIndexPic({
              atlasId: this.picList[i].id,
              isForce: true,
            });
          }

          if (this.picList[i].createUserInfo) {
            this.picList[i].createName = this.picList[i].createUserInfo.name;
          } else {
            this.picList[i].createName = "暂无";
          }

          if (this.picList[i].posterPath === "") {
            this.picList[i].src = require("@/assets/house/onloadpic.png");
          } else {
            this.picList[i].src = picPrefix + this.picList[i].posterPath;
          }

          if (this.picList[i].pictureCount == 0) {
            this.picList[i].src = require("@/assets/house/onloadpic.png");
          }
        }

        this.$forceUpdate();
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
      this.interfaceFlag = true
    },

    isJSON (str) {
      if (typeof str == "string") {
        try {
          var obj = JSON.parse(str);
          if (typeof obj == "object" && obj) {
            return true;
          } else {
            return false;
          }
        } catch (e) {
          console.log("error：" + str + "!!!" + e);
          return false;
        }
      }
      // console.log('It is not a string!')
    },

    //检索图片
    async searchPictureAsync (val) {
      let { status, data, message, pagination, errors } = await searchPicture(
        val
      );
      this.searchLoading = false
      this.loading = false;
      if (status) {
        if (this.pagePic === 0) {
          this.notpicList = data;
        } else {
          for (let i = 0; i < data.length; i++) {
            this.notpicList.push(data[i]);
          }
        }

        this.totalPic = pagination.total;
        for (let i = 0; i < this.notpicList.length; i++) {

          if (this.notpicList[i].fileInfo) {
            if (!this.notpicList[i].fileInfo.picThumbH160) {
              this.notpicList[i].src = require("@/assets/house/onloadpicin.png");
              this.notpicList[i].srcW1080 = require("@/assets/house/onloadpicin.png");
            } else {
              this.notpicList[i].src =
                picPrefix + this.notpicList[i].fileInfo.picThumbH160;
              this.notpicList[i].srcW1080 =
                picPrefix + this.notpicList[i].fileInfo.picThumbW1080;
            }
            //图片加载失败
            if (this.notpicList[i].fileInfo.picThumbH160 === "error") {
              this.notpicList[i].errortext = "error";
              this.notpicList[
                i
              ].src = require("@/assets/house/onloadpicerror.png");
              this.notpicList[
                i
              ].picThumbWh160 = require("@/assets/house/onloadpicerror.png");
              this.notpicList[
                i
              ].srcW1080 = require("@/assets/house/onloadpicerror.png");
            }
            let imgTest = new Image();
            imgTest.src = this.notpicList[i].src;
            imgTest.onerror = () => {
              this.notpicList[i].errortext = "error";
              this.notpicList[
                i
              ].src = require("@/assets/house/onloadpicerror.png");
              this.notpicList[
                i
              ].picThumbWh160 = require("@/assets/house/onloadpicerror.png");
              this.notpicList[
                i
              ].srcW1080 = require("@/assets/house/onloadpicerror.png");
            };
          } else {
            this.notpicList[i].src = require("@/assets/house/onloadpic.png");
            this.notpicList[
              i
            ].picThumbWh160 = require("@/assets/house/onloadpic.png");
            this.notpicList[
              i
            ].srcW1080 = require("@/assets/house/onloadpic.png");
          }

          if (this.notpicList[i].exif && this.isJSON(this.notpicList[i].exif)) {
            this.notpicList[i].exif = JSON.parse(this.notpicList[i].exif);
          }

          this.notpicList[i].isLove = false;
        }
        // console.log('1',this.notpicList)
        let picLoveString = sessionStorage.getItem("picLove");
        let picLoveArray = JSON.parse(picLoveString);
        if (picLoveArray) {
          for (let j = 0; j < picLoveArray.length; j++) {
            for (let z = 0; z < this.notpicList.length; z++) {
              if (picLoveArray[j].id === this.notpicList[z].id) {
                this.loveList.push(picLoveArray[j].id);
                this.notpicList[z].isLove = true;
              }
            }
          }
          this.setLoveList(this.loveList);
        } else {
          this.loveList = [];
          this.setLoveList(this.loveList);
        }

        this.$forceUpdate();
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }

      this.showLoading = false
      this.interfaceFlag = true
      this.showGifFlag = false
    },

    //判断分辨率
    judgRes () {
      // console.log(this.isAside)
      if (this.isAside && this.displayResolution > 1700) {
        this.atlasMargin = "16px";
      } else if (this.isAside && this.displayResolution < 1700) {
        this.atlasMargin = "38px";
      } else if (!this.isAside && this.displayResolution > 1700) {
        this.atlasMargin = "45px";
      } else if (!this.isAside && this.displayResolution < 1700) {
        this.atlasMargin = "75px";
      }
    },

    //判断gril的row值
    checkRow () {
      this.displayResolution = document.documentElement.clientWidth;
      if (this.displayResolution > 2500) {
        this.row = 7;
        this.widthWithUP = "13%";
      } else if (this.displayResolution > 2400) {
        this.row = 6;
        this.widthWithUP = "14%";
      } else if (this.displayResolution > 2000) {
        this.row = 5;
        this.widthWithUP = "16%";
      } else if (this.displayResolution > 1700) {
        this.row = 5;
        this.widthWithUP = "18%";
      }
      if (this.displayResolution <= 1700) {
        this.row = 4;
        this.widthWithUP = "21.5%";
      }
      if (this.displayResolution <= 1600) {
        this.row = 4;
        this.widthWithUP = "22.5%";
      }
      if (this.displayResolution <= 1550) {
        this.row = 4;
        this.widthWithUP = "22.5%";
      }
      if (this.displayResolution <= 1400) {
        this.row = 3;
        this.widthWithUP = "25%";
      }
    },
  },
  created () {
    this.loading = true;


    window.onresize = () => {
      if (!checkFull()) {
        // 退出全屏后要执行的动作
        // console.log("退出全屏")
        this.seeFull = false;
        this.$store.commit("SET_BigImage", false);
      }
    };
    // this.getUserSettingAsync(this.createUid, "picLove");
    this.listPeopleSelectAsync({ page: 0, pageSize: 20 });

    //获取图集
    this.searchAtlasAsync({
      pageSize: this.pageSize,
      page: this.page,
      orderByTime: this.orderByTime,
      status: 1,
    });

    //获取图片邀约
    this.listPictureNeedAsync();

    // setTimeout(() => {
    for (let i = 0; i < 20; i++) {
      let nopic = {
        src: require("@/assets/house/grey.png")
      };
      this.notpicList.push(nopic);
    }
    setTimeout(() => {
      //获取图片
      this.searchPictureAsync({
        pageSize: this.pageSizePic,
        page: this.pagePic,
        orderByTime: this.orderByTimePic
      });
    }, 1000);
    // }, 200);

    //获取图库名字
    this.listLibAsync();
    //获取用户列表
    this.listUserAsync();
    this.displayResolution = document.documentElement.clientWidth;

    setInterval(() => {
      this.judgRes();
    }, 888);
  },
  mounted () {
    window.addEventListener("scroll", this.scrollPic);
    //获取侧边栏是否收起
    this.bus.$on("changeIsaside", (message) => {
      this.bus.val = message;
      this.isAside = this.bus.val;
      // this.isChildren = false
    });
  },
  destroyed () {
    //离开这个界面之后，删除，不然会有问题
    window.removeEventListener("scroll", this.scrollPic);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./piccenter.scss";
@import "@/constants/elHeader.scss";
// ::v-deep .el-select__caret:before {
//   content: "\e78f";
//   font-size: 16px;
//   color: black;

// }
::v-deep .el-input__prefix {
  display: none;
}
::v-deep .el-input__inner {
  padding-left: 18px;
}
.seePic ::v-deep .el-dialog__header {
  display: none;
}
.seePic ::v-deep .el-dialog__body {
  display: flex;
  padding: 0;
}

//改变图片放大的关闭的位置
::v-deep .el-image-viewer__close {
  width: 5000px;
  height: 5000px;
  border-radius: 0%;
}
::v-deep .el-icon-circle-close {
  margin-top: 100px;
  color: white;
}

::v-deep .image-slot {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
